import React, { memo, useEffect } from "react";
import { setTitle } from "@store/title-store";

import { Goskey } from "@feature/goskey";

const GosKey: React.FC = memo(() => {
  useEffect(() => {
    setTitle([
      { title: "Главная", href: "/" },
      { title: "Госключ", href: "/goskey" },
    ]);
  }, []);

  return (
    <main className="content-container">
      <div className="content-section">
        <div>
          <Goskey />
          {/* <BodyBold>
            Раздел находится в разработке. Скоро здесь появится актуальная
            информация
          </BodyBold> */}
        </div>
      </div>
    </main>
  );
});

export default GosKey;
